import './index.less';

import React, { FC, useMemo, useState } from 'react';

import { Popover, Button, Empty } from 'antd';

import { useSelector } from 'react-redux';

import { TStoreData } from '@/interface';

import { pageCollect } from '@/layout/layout.config';

import { useHistory } from 'react-router-dom';

import store from '@/store';

import { routerJump } from '@/util/tools';

import SysConfig from '@/conf/sys.map.config';
import { logout } from '@/util/tools';
import TenantModal from '../tenant-modal';

const oldMenu = {
    oldHead: {
        left: 130,
    },
};

interface TProps {
    oldMenu: boolean;
}

const HeaderContent: FC<TProps> = (props: TProps) => {
    const history = useHistory();

    const storeData = useSelector((data: TStoreData) => {
        return {
            firstTenant: data.firstTenant,
            userInfo: data.user || {},
            flow: data?.flow || [],
            other: data?.other || [],
            quickEntrance: data?.quickEntrance || [],
            customRecord: data?.customRecord,
        };
    });
    const { userInfo, customRecord, firstTenant } = storeData;

    const [open, setOpen] = useState(false);

    const showName = useMemo(() => {
        if (userInfo.userName) {
            if (userInfo.userName.length > 2) {
                return userInfo.userName.slice(1, userInfo.userName.length);
            }
            return userInfo.userName;
        }
        return '无';
    }, [userInfo.userName]);

    return (
        <div className={`lr-layout-header-box`} style={props.oldMenu ? oldMenu.oldHead : {}}>
            {/* 左侧快捷方式 */}
            <div className={`lr-layout-header-box-left`}>
                {pageCollect.map((item) => {
                    const Icon = item.icon;
                    return (
                        <Popover
                            placement="bottomLeft"
                            key={item.title}
                            title={item.title}
                            content={
                                customRecord?.[item.key]?.length ? (
                                    customRecord?.[item.key]?.map((item) => (
                                        <div
                                            key={item.resCode}
                                            className="lr-layout-header-link"
                                            onClick={() => routerJump(history, item)}
                                        >
                                            {item.name}
                                        </div>
                                    ))
                                ) : (
                                    <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description={'暂无数据'}
                                    />
                                )
                            }
                            trigger="hover"
                        >
                            <div className={`lr-layout-header-icon`}>
                                <Icon />
                            </div>
                        </Popover>
                    );
                })}
                {SysConfig.headerLeft.map((Comp: any, index) => {
                    return <Comp key={index} />;
                })}
            </div>

            {/* 右侧快捷方式 */}
            <div className={`lr-layout-header-box-right`}>
                <div className="lr-layout-header-user">
                    <div className="lr-layout-header-user-avatar" onClick={() => setOpen(true)}>
                        {showName}
                    </div>
                    <div className="lr-layout-header-user-org" onClick={() => setOpen(true)}>
                        {firstTenant.orgName || '--'}
                    </div>
                    <Popover
                        placement="bottomRight"
                        trigger="click"
                        content={
                            <div>
                                <Button type="text" onClick={logout}>
                                    退出登录
                                </Button>
                            </div>
                        }
                    >
                        <div className="lr-layout-header-user-img"></div>
                    </Popover>
                </div>
            </div>
            <TenantModal
                open={open}
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {
                    setOpen(false);
                }}
            ></TenantModal>
        </div>
    );
};
export default HeaderContent;
